import { FC } from 'react';

import { Container, Content } from './styles';

const AuthLayout: FC = ({ children }) => {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
};

export default AuthLayout;
